export const TEST = 'TEST';
export const TARIFFS = 'TARIFFS';

export const SET_SUBTITLE_TEXT = 'SET_SUBTITLE_TEXT';

export const DEFAULT_PRODUCT_ID = 1;

export const MENU_PAYMENT = 'MENU_PAYMENT';

export const CUSTOM_BILLS = 'CUSTOM_BILLS';
